var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3536 0.638184H15.3438V2.00082H17.3536C17.7284 2.00082 18.035 2.30741 18.035 2.68214V4.69202H19.3976V2.68214C19.3976 1.55796 18.4778 0.638184 17.3536 0.638184Z",
    fill: "#166649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68295 2.68214C1.68295 2.30741 1.98954 2.00082 2.36426 2.00082H4.37415V0.638184H2.36426C1.24009 0.638184 0.320312 1.55796 0.320312 2.68214V4.69202H1.68295V2.68214Z",
    fill: "#166649"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68295 17.671V15.6611H0.320312V17.671C0.320312 18.7952 1.24009 19.715 2.36426 19.715H4.37415V18.3523H2.36426C1.98954 18.3523 1.68295 18.0457 1.68295 17.671Z",
    fill: "#166649"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.035 17.671C18.035 18.0457 17.7284 18.3523 17.3536 18.3523H15.3438V19.715H17.3536C18.4778 19.715 19.3976 18.7952 19.3976 17.671V15.6611H18.035V17.671Z",
    fill: "#166649"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45346 11.5051H5.09083C3.96665 11.5051 3.04688 12.4249 3.04688 13.5491V14.8776C3.04688 16.0018 3.96665 16.9216 5.09083 16.9216H6.45346C7.57763 16.9216 8.49741 16.0018 8.49741 14.8776V13.5491C8.49741 12.4249 7.57763 11.5051 6.45346 11.5051ZM7.13478 14.8776C7.13478 15.2524 6.82818 15.559 6.45346 15.559H5.09083C4.7161 15.559 4.40951 15.2524 4.40951 14.8776V13.5491C4.40951 13.1744 4.7161 12.8678 5.09083 12.8678H6.45346C6.82818 12.8678 7.13478 13.1744 7.13478 13.5491V14.8776Z",
    fill: "#166649"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45283 3.36353H5.19239C4.06822 3.36353 3.14844 4.2833 3.14844 5.40748V6.73604C3.14844 7.86022 4.06822 8.78 5.19239 8.78H6.45283C7.577 8.78 8.49678 7.86022 8.49678 6.73604V5.40748C8.49678 4.2833 7.577 3.36353 6.45283 3.36353ZM7.13414 6.73604C7.13414 7.11077 6.82755 7.41736 6.45283 7.41736H5.19239C4.81766 7.41736 4.51107 7.11077 4.51107 6.73604V5.40748C4.51107 5.03275 4.81766 4.72616 5.19239 4.72616H6.45283C6.82755 4.72616 7.13414 5.03275 7.13414 5.40748V6.73604Z",
    fill: "#166649"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6963 8.81393C15.8205 8.81393 16.7402 7.89415 16.7402 6.76998V5.44141C16.7402 4.31724 15.8205 3.39746 14.6963 3.39746H13.2315C12.1073 3.39746 11.1875 4.31724 11.1875 5.44141V6.76998C11.1875 7.89415 12.1073 8.81393 13.2315 8.81393H14.6963ZM12.5501 6.73591V5.40735C12.5501 5.03262 12.8567 4.72603 13.2315 4.72603H14.6963C15.071 4.72603 15.3776 5.03262 15.3776 5.40735V6.73591C15.3776 7.11064 15.071 7.41723 14.6963 7.41723H13.2315C12.8567 7.4513 12.5501 7.14471 12.5501 6.73591Z",
    fill: "#166649"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7392 16.9558V12.8679H12.6172V14.2646H15.3765V16.9558H16.7392Z",
    fill: "#166649"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9458 15.6272H12.6172V16.9898H13.9458V15.6272Z",
    fill: "#166649"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2543 11.5732H9.92578V12.9359H11.2543V11.5732Z",
    fill: "#166649"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.015 10.1765H12.6523V11.5051H14.015V10.1765Z",
    fill: "#166649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrQrcode);
export default __webpack_public_path__ + "static/media/ubr-qrcode.0d0eb810b528fe08ca268381e216281a.svg";
export { ForwardRef as ReactComponent };